// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".case-study{padding-bottom:5px}.home-tile-subtitle{font-weight:700;margin-bottom:1em}.thumbnail{width:\"318\";height:\"auto\";margin-top:.5em;margin-bottom:.75em}.button{margin-top:.3em;margin-bottom:0}.featured-thumbnail{width:\"318\";height:\"auto\";margin:0;padding:0}.longbar{width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
